import { useDispatch, useSelector, useStore } from "react-redux";
import * as Yup from "yup";
import { SportCodes } from "@prestosports/prestostats-core/Common";
import { getRuleSetOptions as getRuleSetOptionsAction } from "./actions";

const useSportContext = () => {
	const dispatch = useDispatch();
	const store = useStore();

	const useAllowedPositions = () =>
		useSelector((state) => state.sport.allowedPositions);

	const useAllowedYears = () => useSelector((state) => state.sport.allowedYears);

	const useRuleSetOptions = () =>
		useSelector((state) => state.sport.ruleSetOptions);

	const state = {
		allowedPositions: useAllowedPositions,
		allowedYears: useAllowedYears,
		ruleSetOptions: useRuleSetOptions
	};

	const getRuleSetOptions = () => {
		const { currentSeason } = store.getState().season;
		const { sportId } = currentSeason.sport;
		getRuleSetOptionsAction(sportId, dispatch);
	};

	const getCustomValidation = () => {
		const { currentSeason } = store.getState().season;
		const { sportId } = currentSeason.sport;

		if ([SportCodes.Tennis, SportCodes.WomenTennis].includes(sportId)) {
			return {
				singles: Yup.object().shape({
					numberOfMatches: Yup.number()
						.required("Required")
						.test(
							"min-matches",
							"At least one match is required",
							(value, schema) => {
								const singles = value;
								const doubles = schema.from[1].value?.doubles?.numberOfMatches;

								if (singles !== undefined && doubles !== undefined) {
									return doubles + singles > 0;
								}
								return true;
							}
						)
				}),
				doubles: Yup.object().shape({
					numberOfMatches: Yup.number()
						.required("Required")
						.test(
							"min-matches",
							"At least one match is required",
							(value, schema) => {
								const singles = schema.from[1].value?.singles?.numberOfMatches;
								const doubles = value;

								if (singles !== undefined && doubles !== undefined) {
									return doubles + singles > 0;
								}
								return true;
							}
						)
				})
			};
		}

		return null;
	};

	return {
		state,
		getRuleSetOptions,
		getCustomValidation
	};
};

export { useSportContext };
